import * as z from "zod";

export enum AttachmentField {
  License = "Contractor Trade License",
  Person = "Persons list",
  Vehicle = "Vehicle list",
  Passport = "Passport",
  Other = "Other documents",
}

export const AttachmentFieldEnum = z.nativeEnum(AttachmentField);

export enum AttachmentFieldLabel {
  License = "Contractor Trade Licence",
  Person = "Persons list",
  Vehicle = "Vehicle list",
  Passport = "Passport",
  Other = "Other documents",
}
